import { createFileRoute } from '@tanstack/react-router';
import { IconLeaguePage } from '@pages/icon-league';
import { CmsPageRenderer } from '@pages/cms-page';

/**
 * ICON League — rendert CMS-Inhalt wenn verfügbar, sonst Fallback auf hartkodierte Event-Liste.
 */
function IconLeagueRoute() {
  return <CmsPageRenderer slug="icon-league" fallback={<IconLeaguePage />} />;
}

export const Route = createFileRoute('/icon-league')({ component: IconLeagueRoute });
